/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Paper,
  MuiThemeProvider,
  Button,
  useMediaQuery,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { tableMuiTheme } from "../../table/table_styles";
import TagDialog from "./TagDialog";
import * as tagsDUCK from "../../../../redux/ducks/tags.duck";
import { setLoader } from "../../../../redux/ducks/load.duck";
import { getTag, defaultTag, getTags } from "../../../crud/api/tags.crud";
import CustomTableFooter from "../../../utils/CustomTableFooter";
import { setAlert } from "../../../../redux/ducks/alert.duck";
import MUIDataTable from "mui-datatables";

const Tags = ({ tags, tagsActions, settingLoader, school, setAlertModal }) => {
  const isTablet = useMediaQuery("(min-width: 768px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const [dialog, setDialog] = useState("close");
  const [query] = useState("");

  useEffect(() => {
    if (school && school !== null) {
      if (query && query.length > 1) getTags(tagsActions.setTags, 1, query);
      else getTags(tagsActions.setTags, 1);
    }
  }, [query, school, tagsActions.setTags]);

  const openDialog = (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        tagsActions.setTag(defaultTag);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        getTag(tagsActions.setTag, id).then(() => setDialog(mode));
        break;
      case "close":
        settingLoader(true);
        setDialog(mode);
        setTimeout(() => {
          tagsActions.setTag(defaultTag);
        }, 500);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const isTagProAthlete = (meta) => {
    const tag = tags.data[meta.rowIndex];
    return tag.is_pro_athlete;
  };

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "is_pro_athlete",
      label: "Pro atlhete",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => (
          <Checkbox checked={isTagProAthlete(meta)} disabled />
        ),
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => (
          <div className="d-flex">
            <Tooltip title="Edit Focus Area" placement="top">
              <a
                id={`edit_focus_areas_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-primary "
                onClick={() => openDialog("editing", value)}
              >
                <i className="fas fa-edit text-primary" />
              </a>
            </Tooltip>
            {/* <Tooltip title="Delete Focus Area" placement="top">
              <a
                id={`delete_focus_areas_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-danger text-danger mx-3"
                onClick={() =>}
              >
                <Delete />
              </a>
            </Tooltip> */}
          </div>
        ),
      },
    },
  ];

  const options = {
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: tags.rowsPerPage,
    page: tags.page,
    count: tags.count,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "670px" : isTablet ? "640px" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "subfactors.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={(mPage) => {
          settingLoader(true);
          getTags(tagsActions.setTags, mPage, query)
            .catch((error) => {
              console.error("Failed to fetch tags:", error);
            })
            .finally(() => settingLoader(false));
        }}
      />
    ),
  };

  return (
    <div className="table-container">
      <div className="pb-4 d-flex justify-content-end align-items-end">
        <Button
          id="create_tag_btn"
          variant="contained"
          color="secondary"
          onClick={() => openDialog("create")}
        >
          <Add /> New Tag
        </Button>
      </div>

      <Paper>
        <MuiThemeProvider theme={tableMuiTheme()}>
          <MUIDataTable columns={columns} data={tags.data} options={options} />
        </MuiThemeProvider>
      </Paper>

      <TagDialog mode={dialog} setDialog={openDialog} />
    </div>
  );
};

const mapStateToProps = (store) => ({
  tags: store.tags.tags,
  school: store.school.selected_school,
  is_admin: store.auth.user?.is_admin,
  staff_member_admin: store.auth.user?.staff_member_admin,
});

const mapDispatchToProps = (dispatch) => ({
  tagsActions: bindActionCreators(tagsDUCK.actions, dispatch),
  settingLoader: bindActionCreators(setLoader, dispatch),
  setAlertModal: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Tags);
